export default __webpack_public_path__ + "static/media/doodle.646f841e.jpg";